import Butterfly from "./Butterfly";

class ButterflySubfamily {
    public commonName: string;
    public scientificName: string;
    public speciesList: Array<Butterfly>

    constructor(commonName: string, scientificname: string) {
        this.commonName = commonName;
        this.scientificName = scientificname;
        this.speciesList = [];
    }
}

export default ButterflySubfamily;